import { render } from "./LoadsheddingDetails.vue?vue&type=template&id=1d1db7cb"
import script from "./LoadsheddingDetails.vue?vue&type=script&lang=js"
export * from "./LoadsheddingDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__